<template>
  <InputContainer
    v-model="modelValue"
    :size="props.size"
    :validation-state="props.validationState"
    :icon-state="props.iconState"
    :icon-name="props.iconName"
    :deletable="props.deletable"
    :readonly="props.readonly"
    :disabled="props.disabled"
    :input-type="props.inputType"
    :alertLabel="props.alertLabel"
    :alertType="props.alertType"
    :read-only-reason="props.readOnlyReason"
  >
    <input
      type="text"
      :id
      v-model="modelValue"
      :placeholder="props.placeholder"
      :maxlength="props.maxlength"
      :readonly="props.readonly"
      :disabled="props.disabled"
      :style="props.disabled === true && (modelValue?.length && modelValue?.length > 0) ? 'color: black !important;' : ''"
    />
  </InputContainer>
</template>

<script setup lang="ts">
  import { useAutoId, type AlertInputProps, type InputModel, type InputProps } from '@designSystem/components'

  const props = withDefaults(defineProps<InputProps & AlertInputProps>(), {
    size: 'medium',
    readonly: false,
    disabled: false,
    hasBg: false,
    wrap: false,
    hasLabel: true,
    maxLength: undefined,
    readOnlyReason: undefined,
  })

  const modelValue = defineModel<InputModel>()

  const id = useAutoId('input')
</script>
<style lang="less">
  @import './BasicInput.less';
</style>
